import './style.scss';
import copyToClipboard from 'clipboard-copy';

document.addEventListener('DOMContentLoaded', () => {
    const mainClass = 'genera-package';
    const initializedClass = 'initialized';
    const collapseShowClass = 'show';
    const couponCopiedClass = 'copied';

    const packages = document.querySelectorAll(`.${mainClass}:not(.${initializedClass})`);

    packages.forEach((element) => {
        const coupon = element.querySelector('.package-coupon-text');
        const isExpandable = element.classList.contains('has-expandable-info');

        if (coupon) {
            const couponText = coupon.dataset.clipboardText;

            coupon.addEventListener('click', (e) => {
                const copy = copyToClipboard(couponText);
                copy.then((e) => {
                    coupon.classList.add(couponCopiedClass);
                    
                    setTimeout(() => {
                        coupon.classList.remove(couponCopiedClass);
                    }, 3000);
                });
            });
        }

        if (isExpandable) {
            const checkbox = element.querySelector('input');
            const label = element.querySelector('label .text');
            const content = element.querySelector('.package-expandable-content');

            checkbox.addEventListener('change', (e) => {
                label.innerText = checkbox.checked ? label.dataset.openedText : label.dataset.closedText;
                content.classList.toggle(collapseShowClass, checkbox.checked);
            });
        }

        element.classList.add(initializedClass);
    })
});
